import './ScorePill.css'
import {ReactSVG} from "react-svg";
import {ReactNode} from "react";

// treat non-numeric values as 0 to not break, not that it should ever be used that way
function sumValues(values: ReactNode | string[] | number[]) {
    if (Array.isArray(values)) {
        return values.reduce((sum: number, value) => sum + (typeof value === 'number' ? value : 0), 0);
    }
    return typeof values === 'number' ? values : 0;
}

export default function ScorePill({icon, value, goal, className}: {icon: string | ReactNode, value: ReactNode | string[] | number[], goal?: number, className?: string }) {
    return <div className={`scorePill ${className ? className : ''}`} style={{'--pill-item-count': Array.isArray(value) ? value.length : 1}}>
        <div className={"label"}>
            {typeof icon == 'string' ? <div className={`svgWrapper ${icon.includes("@fontawesome") ? 'fontAwesome' : ''}`}>
                <ReactSVG src={icon} />
            </div> : icon}
        </div>
        <div className={"value"}>
            {Array.isArray(value) ? value.map((v, idx) => <div key={idx} className={"valueWrapper"}>{v}</div>) : <div className={"valueWrapper"}>{value}</div>}
        </div>
        {goal ? <div className={"goal"}>
            {sumValues(value) >= goal ? <i className={"fa fa-fw fa-check"}></i> : `/${goal}`}
        </div> : null}
    </div>
}